export default __webpack_public_path__ + "static/media/eamcs_bg_med.199df88f.jpg";